import React from "react"
import { Link, useLocation } from "react-router-dom"

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"

const ROUTE_LABELS: Record<string, string> = {
  "": "Tableau de bord",
  reservations: "Réservations",
  new: "Nouvelle réservation",
  agenda: "Agenda",
  rooms: "Salles",
  availability: "Disponibilités",
  buildings: "Bâtiments",
  admin: "Administration",
  users: "Utilisateurs",
  roles: "Rôles",
  settings: "Paramètres",
  invitations: "Invitations",
  activity: "Journal d'activité",
  profile: "Profil",
  notifications: "Préférences de notification",
  my: "Mes réservations",
  "calendar-sync": "Flux iCal",
  tablet: "Tablette",
  devices: "Appareils",
  equipment: "Équipements",
  help: "Aide",
  "forgot-password": "Mot de passe oublié",
  "reset-password": "Réinitialisation du mot de passe",
}

function getLabel(segment: string): string {
  return ROUTE_LABELS[segment] ?? segment
}

function isUuid(segment: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment)
}

// Segments that are only prefixes (no standalone route)
const NON_LINKABLE_SEGMENTS = new Set(["admin", "my"])

export function DynamicBreadcrumb() {
  const location = useLocation()
  const segments = location.pathname.split("/").filter(Boolean)

  // Build breadcrumb items
  const crumbs = segments.map((segment, index) => {
    const path = "/" + segments.slice(0, index + 1).join("/")
    const label = isUuid(segment) ? "Détail" : getLabel(segment)
    const isLast = index === segments.length - 1
    const isLinkable = !NON_LINKABLE_SEGMENTS.has(segment)

    return { path, label, isLast, isLinkable }
  })

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem className="hidden md:block">
          <BreadcrumbLink asChild>
            <Link to="/dashboard">Meeting</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        {crumbs.map((crumb) => (
          <React.Fragment key={crumb.path}>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              {crumb.isLast || !crumb.isLinkable ? (
                <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link to={crumb.path}>{crumb.label}</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        ))}

        {/* Si on est à la racine, afficher "Tableau de bord" comme page courante */}
        {crumbs.length === 0 && (
          <>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage>Tableau de bord</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
